import React from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
import ContnueButton from './ContinueButton';

import './MedicalDispenserUI.css'

const MedicalDispenserUI = (props: UIProperties<MedicalDispenserUIConfig>) => {

	const getReceiptText = () => {
		return`
		Discrepancy Receipt. 

		Tramadol 50 milligrams Tab. 

		Monday. January 27 at 11 37 with 49 seconds. 

		Main Zone 1. Drawer 7. bin 12. 

		checked by Marco. 

		discrepancy Transaction. 

		Quantity Expected 20 Tabs. 

		Quantity Found 17 Tabs. 

		Quantity Adjusted Down 3 Tabs. 

		Quantity Remaining 17 Tabs. 

		Witness. Heather.
		`;
	}
	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div tabIndex={0} id='med-dispenser-ui-first' aria-label='Medical Dispenser' className="medical-dispenser-container">
				<img src="./assets/images/general/backgrounds/medical-dispenser.png"/>
				<img tabIndex={0} aria-label={getReceiptText()} style={{
					position: 'absolute',
					top: '80px',
					left: '50%',
					width: '410px',
					transform: 'translate(-50%, 0)'
				}} src={props.parameters.image} />
				<ContnueButton parameters= {{
					id: 'med-dispenser-ui-last',
					top: '651px',
					left: '511px',
					width: '190px',
					onClicked: () => {
						props.parameters.onClose();
					}
				}}/>
			</div>
			
		</div>
	);

};

export interface MedicalDispenserUIConfig extends BaseConfig {
	image: string;
	onClose: () => void;
}

export default MedicalDispenserUI;